import EntryActionTypes from '../constants/EntryActionTypes';

const fetchCardPointDataInCurrentCard = () => ({
  type: EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_FETCH,
});

const upsertCardPointDataInCurrentCard = (data) => ({
  type: EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_UPSERT,
  payload: {
    data,
  },
});

const completeCardPointDataInCurrentCard = () => ({
  type: EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_COMPLETE,
});

const uncompleteCardPointDataInCurrentCard = () => ({
  type: EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_UNCOMPLETE,
});

export default {
  fetchCardPointDataInCurrentCard,
  upsertCardPointDataInCurrentCard,
  completeCardPointDataInCurrentCard,
  uncompleteCardPointDataInCurrentCard,
};

